import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { QuizQuestionAnswer } from '@digilize/shared/definitions/src';
import { AbcStyleClass } from '@digilize/shared/ui/components/src';

@Component({
  selector: 'lsl-single-exercise',
  templateUrl: './single-exercise.component.html',
  styleUrls: ['./single-exercise.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SingleExerciseComponent implements OnInit {
  @Input() answers: QuizQuestionAnswer[];
  @Input() answerValidation: QuizQuestionAnswer;
  @Input() validAnswers: QuizQuestionAnswer[];
  @Input() form;
  constructor() {}

  ngOnInit() {}

  getStyleClass(answer: QuizQuestionAnswer): AbcStyleClass {
    if (!this.answerValidation || !this.validAnswers) return false;
    if (answer.id === this.answerValidation.id) {
      return this.answerValidation.valid ? 'correct' : 'error';
    }
    if (this.validAnswers.find((valid) => valid.id === answer.id)) {
      return 'correct';
    }
    return false;
  }
}
